import React, { useState, useEffect, } from 'react';
import { useHistory } from "react-router-dom";
import { Label } from '../atoms/label';
import { Image } from "../atoms/image";
import { WeeksDate } from '../molecules/weeksDate';
import { WeeksDateMobile } from '../molecules/weeksDateMobile';
import useMedia from "use-media";
import { connect } from 'react-redux';
import img_arw from '../../resources/icons/arw_pulldown.svg';
import img_search from '../../resources/icons/ico_search.svg';
import { GetPublicHoliday } from "../../hooks/getPublicHoliday";
import { searchResultApi } from "../../const";
import img_modal from '../../resources/icons/ico_modal.svg';
import common from "../../resources/js/common/common";
import circle from '../../resources/icons/ico_circle.svg';
import triangle from '../../resources/icons/ico_triangle.svg';
import square from '../../resources/icons/ico_square.svg';
import cross from '../../resources/icons/ico_X.svg';
import arrow from '../../resources/icons/arw.svg';
import { ImageButton } from '../atoms/imageButton';
import "../../resources/css/search/search.css";
import { now } from 'moment';

const VacancyInfoContainerCallender = (props) => {
    const {
        playDate2,
        group,
        startTime,
        course,
        setCourse,
        setGroup,
        setPlayDate1,
        setSearchResult,
        onClickPlay,
        onClickOpenStartTimeWindow,
        displaySwitch,
        setReserveCheckInfo,
        kaiinken,
        setChangeReserveNo,
        addTeeTimeList,
        changeReserveNo,
        onClickMoveWeeks,
        getCalendarStartDate,
        onClickOpenFacilityCalendarWindow } = props;

    const { getHoliday } = GetPublicHoliday();

    const isMobilePhone = useMedia({ maxWidth: '480px' });
    const [mobilePhone, setMobilePhone] = useState(false);
    const [nextFlag, setNextFlag] = useState(false);
    const [NotSearch, setNotSearch] = useState(false)


    const history = useHistory();
    let twoWeeks = [];

    useEffect(() => {
        if (isMobilePhone) {
            setMobilePhone(true);
        } else {
            setMobilePhone(false);
        }
    }, [isMobilePhone]);




    // モバイル版のカレンダー切替
    const onClickNextView = () => {
        setNextFlag(!nextFlag);
    }



    // 〇△を押下した場合の処理
    const toList = (courseId, date) => {
        addTeeTimeList([]);
        setReserveCheckInfo([]);
        setChangeReserveNo("");
        for (let i in course) {
            if (course[i].id === courseId) {
                course[i].checked = true;
            } else {
                course[i].checked = false;
            }
        }
        setCourse(course);
        setPlayDate1(date);

        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();

        if (m < 10) m = `0${m}`
        if (d < 10) d = `0${d}`

        const startTimeArray = [];
        startTime.forEach((data) => {
            if (data.checked === true) startTimeArray.push(data.id);
        });

        let groupNumber = 1;
        group.forEach((data) => {
            if (data.selected === true) groupNumber = parseInt(data.id); 
        });

        let useMemberShipAuth;
        let kaiinKind;
        let courseArrayKaiinken;
        kaiinken.forEach((data) => {
            if (data.selected === true) {
                courseArrayKaiinken = data.sisetuCd;
                kaiinKind = data.kaiinkenSyubetCd;
                course.forEach((courseData) => {
                    if(courseData.id === data.facilityCd){
                        useMemberShipAuth = courseData.memberShipAuth
                    }
                })
            }
        });

        // リクエスト情報設定
        const req = {
            playDate: `${y}-${m}-${d}`,
            partyCount: groupNumber,
            courseId: [courseId],
            playStyle: [],
            teeTime: startTimeArray,
            days: '1',
            membershipAuthID:useMemberShipAuth,
            userFacility: courseArrayKaiinken,
            kaiinKind:kaiinKind,
        };
        console.log("カレンダー検索APIリクエスト");
        console.log(req);

        common.doPost(searchResultApi, req, afterToList);
    }

    // 〇△押下後処理
    const afterToList = (res) => {
        const data = res.data;
        if (data.golfCourses === undefined) {
            // 取得エラー処理
            setNotSearch(true);
            common.scrollWindow("condition");
            return;
        }
        const result = course.map((item) => {
            for (let i = 0; i < data.golfCourses.length; i++) {
                if (data.golfCourses[i].name === item.value) {
                    const resData = data.golfCourses[i];
                    const fac = {
                        courseid: item.courseid,
                        zip: item.zip,
                        address: item.address,
                        access_car: item.access_car,
                        facility_overview_title: item.facility_overview_title,
                        facility_overview_detail: item.facility_overview_detail,
                        url: item.url,
                        image_path: item.image_path,
                    }
                    Object.assign(resData, fac);
                    return resData;
                }
            }
            return null;
        });
        const re = result.filter(item => item != null);

        const resultData = {
            golfCourses: re
        }

        setSearchResult(resultData);

        // 画面遷移
        history.push("/reserve/golf/searchResult");
    }

    const onClickFacility = (facilityId, facilityName) => {
        console.log("施設ID"+facilityId);

        // 2週間カレンダーのスタート日
        let startDate2w = getCalendarStartDate();
        let startDate = new Date(startDate2w);
        startDate.setMonth(startDate.getMonth() - 1);
        startDate.setDate(25);
        let nowDate = new Date();
        nowDate.setHours(0);
        nowDate.setMinutes(0);
        nowDate.setSeconds(0);
        nowDate.setMilliseconds(0);
        
        console.log("startDate:"+startDate);
        console.log("nowDate:"+nowDate);

        if((startDate2w.getFullYear() === nowDate.getFullYear() 
            && startDate2w.getMonth() === nowDate.getMonth()) || nowDate >= startDate){
                startDate.setFullYear(nowDate.getFullYear());
                startDate.setMonth(nowDate.getMonth());
                startDate.setDate(nowDate.getDate() + 3);
        }
        let y = startDate.getFullYear();
        let m = startDate.getMonth() + 1;
        let d = startDate.getDate();

        if (m < 10) m = `0${m}`
        if (d < 10) d = `0${d}`

        let groupNumber = 1;
        group.forEach((data) => {
            if (data.selected === true) groupNumber = parseInt(data.id); 
        });

        const startTimeArray = [];
        startTime.forEach((data) => {
            if (data.checked === true) startTimeArray.push(data.id);
        });
        const startTimeStr =  startTimeArray.join();

        const courseArray = [];
        courseArray.push(facilityId);

        //選択された会員権から施設コードを詰め込む
        let courseArrayKaiinken;
        let useMemberShipAuth;
        let kaiinKind;
        kaiinken.forEach((data) => {
            if (data.selected === true) {
                courseArrayKaiinken = data.sisetuCd;
                kaiinKind = data.kaiinkenSyubetCd;
                course.forEach((courseData) => {
                    if(courseData.id === data.facilityCd){
                        useMemberShipAuth = courseData.memberShipAuth
                    }
                })
            }
        });

        const req = {
            startDate: `${y}-${m}-${d}`, 
            teeTime: startTimeStr, 
            partyCount: groupNumber,
            membershipAuthID:useMemberShipAuth,
            userFacility: courseArrayKaiinken,
            kaiinKind:kaiinKind,
            courseId: courseArray,
            syoriKbn:"1"
        }
        onClickOpenFacilityCalendarWindow(req, facilityName, startDate2w);
    }

    return (
        <div style={{ width: "100%" }}>
            <div style={mobilePhone ? { width: "100%" } : { width: "100%", overflowY: "auto", overflowX: "hidden", }}>
                {/* {mobilePhone ?  */}
                <div style={{ display: "flex", justifyContent: "space-between", width: "calc(100% - 40px)", margin: "0px auto", }}>
                    <ImageButton btnClass={"arrowBtn"} imgClass={"arrowBack golf_cursor"} onClick={() => onClickMoveWeeks("back", mobilePhone)} image={arrow} />
                    <div>{props.MonthHead}</div>
                    <ImageButton btnClass={"arrowBtn"} imgClass={"arrowNext golf_cursor"} onClick={() => onClickMoveWeeks("next", mobilePhone)} image={arrow} />
                </div>
                  {/* : <div style={{ marginBottom: "1rem", }}>{!nextFlag ? props.MonthHead : props.MonthLast}</div>} */}
                {mobilePhone ?
                    <div style={props.vacancyInfo.length > 3 ? style.tableSP2 : style.tableSP1}>
                        {props.vacancyInfo !== undefined && props.vacancyWeek !== undefined ? props.vacancyInfo.length !== 0 &&  props.vacancyWeek.length !== 0 ? <WeeksDateMobile data={props.vacancyWeek} data2={props.vacancyInfo} onClick={toList} onClickFacility={onClickFacility}  />
                            : null : null
                        }
                    </div> :
                    <div style={props.vacancyInfo.length > 4 ? style.tablePC2 : style.tablePC1}>
                        {props.vacancyInfo !== undefined && props.vacancyWeek !== undefined ? props.vacancyInfo.length !== 0 &&  props.vacancyWeek.length !== 0 ?  <WeeksDate data={props.vacancyWeek} data2={props.vacancyInfo} onClick={toList} onClickFacility={onClickFacility}  />
                            : null : null
                        }
                    </div>
                }
            </div>
            <div style={{ textAlign: "left", display: "flex", marginTop: "1rem", marginLeft: "10px" }}>
                <div style={style.tableImageStyle}>
                    <Image image={circle} style={mobilePhone ? style.imageStyleMobile : style.imageStyle} />
                    <Label label={":空きあり"} style={mobilePhone ? style.usageGuideMobile : style.usageGuide} />
                </div>
                <div style={style.tableImageStyle} >
                    <Image image={triangle} style={mobilePhone ? style.imageStyleMobile : style.imageStyle} />
                    <Label label={":空きわずか"} style={mobilePhone ? style.usageGuideMobile : style.usageGuide} />
                </div>
                <div style={style.tableImageStyle} >
                    <Image image={square} style={mobilePhone ? style.imageStyleMobile : style.imageStyle} />
                    <Label label={":キャンセル待ち"} style={mobilePhone ? style.usageGuideMobile : style.usageGuide} />
                </div>
                <div style={style.tableImageStyle} >
                    <Image image={cross} style={mobilePhone ? style.imageStyleMobile : style.imageStyle} />
                    <Label label={":空きなし：対象外日"} style={mobilePhone ? style.usageGuideMobile : style.usageGuide} />
                </div>
            </div>
        </div>
    );
}


const style = {
    container: {
        // width: "75%",
        marginRight: "auto",
        marginLeft: "auto",
        // backgroundColor: "white",
    },
    container2: {
        backgroundColor: "pink",
        marginRight: "auto",
        marginLeft: "auto",

    },
    vacancy__title: {
        fontWeight: "bold",
        textAlign: "left",
        marginBottom: "20px",
        height: "25px",
    },
    link: {
        textDecoration: "none",
        color: "#3d7ab3",
        fontWeight: "bold",
        fontSize: "11px",
        float: "right",
    },
    line: {
        clear: "both",
    },
    searchConditions: {
        width: "100%",
    },
    searchbox: {
        width: "100%",
        paddingBottom: "50px",
        margin: "10px auto"
    },
    btnReservation: {
        backgroundColor: "black",
        color: "white",
        border: "1px solid black",
        backgroundImage: `url(${img_search})`,
        backgroundSize: '60% 60%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: "left 10% bottom 45%",
        fontSize: "small",
        padding: "10px 50px",
        cursor: "pointer",
        width: "40%"
    },
    btnReservationMobile: {
        backgroundColor: "black",
        color: "white",
        border: "1px solid black",
        backgroundImage: `url(${img_search})`,
        backgroundSize: '60% 60%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: "left 10% bottom 45%",
        fontSize: "small",
        padding: "10px 50px",
        cursor: "pointer",
        width: "100%"
    },
    labelStyle: {
        width: "9rem",
        lineHeight: "1.2rem",
        verticalAlign: "middle",
        letterSpacing: "0.2rem",
        display: "block",
    },
    labelStyle2: {
        lineHeight: "1.2rem",
        display: "inline-block",
        marginLeft: 7
    },
    selectStyle: {
        display: "inline-block",
        width: "5rem",
        height: "2rem",
        border: "solid 1px #b7b7b7",
        padding: "0 35px 0 10px",
        borderRadius: 2,
    },
    yearStyle: {
        fontWeight: "bold",
        fontSize: "1rem",
    },
    yearStyleMobile: {
        fontWeight: "bold",
        fontSize: "0.6rem",
    },
    monthStyle: {
        fontWeight: "bold",
        fontSize: "1.5rem",
        marginLeft: "10px",
    },
    monthStyleMobile: {
        fontWeight: "bold",
        fontSize: "1rem",
        marginLeft: "10px",
    },
    usageGuide: {
        fontSize: "0.7rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 1.5rem 0.5rem 0.2rem",

    },
    usageGuideMobile: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 0.5rem 0.5rem 0.2rem",

    },
    tablePC1: {
        width: "100%",
        maxHeight: "450px",
    },
    tablePC2: {
        width: "100%",
        overflowX: "hidden",
        overflowY: "scroll",
        maxHeight: "450px",
    },
    tableSP1: {
        width: "100%",
        maxHeight: "250px",
    },
    tableSP2: {
        width: "100%",
        overflowX: "hidden",
        overflowY: "scroll",
        maxHeight: "250px",
    },
    label: {
        color: "#696969",
        margin: "5px 0",
        fontSize: "small",
    },
    modalOptionStyle: {
        backgroundColor: "#fff",
        border: "solid 1px #adadad",
        padding: "10px 20px",
        position: "relative",
        display: "block",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        backgroundImage: `url(${img_modal})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: "right 10px center",
        cursor: "pointer",
    },
    wrap: {
        width: "48%",
        textAlign: "left",
        marginBottom: "20px",
    },
    wrapMobile: {
        width: "100%",
        textAlign: "left",
        marginBottom: "20px",
    },
    search: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
    },
    searchMobile: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        marginBottom: "20px",
    },
    pullDownOptionStyle: {
        border: "solid 1px #adadad",
        padding: "10px 20px",
        width: "100%",
        outline: "none",
        appearance: "none",
        backgroundImage: `url(${img_arw})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: "right 10px center",
        cursor: "pointer",
    },
    tableImageStyle: {
        display: "flex",
    },

    imageStyle: {
        width: "13px",
    },
    imageStyleMobile: {
        width: "13px",
    }
}

const mapStateToProps = (state) => {
    return {
        playDate2: state.playDate2,
        group: state.group,
        startTime: state.startTime,
        course: state.course,
        kaiinken:state.kaiinken,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setGroup: (item) => {
            dispatch({ type: "GROUP", payload: { group: item } })
        },
        setPlayDate1: (item) => {
            dispatch({ type: "SELECT_PLAY_DATE1", payload: { playDate1: item } })
        },
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setReserveCheckInfo: (item) => {
            dispatch({ type: "RESERVE_CHECK_INFO", payload: { reserveCheckInfo: item } })
        },
        setChangeReserveNo: (item) => {
            dispatch({ type: "CHANGE_RESERVE_NO", payload: { changeReserveNo: item } })
        },
        addTeeTimeList: (item) => {
            dispatch({ type: "ADD_TEETIME_LIST", payload: { teeTimeList: item } })
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VacancyInfoContainerCallender);